export default "<ngb-alert *ngIf=\"show\" [type]=\"model.type\" (close)=\"close()\" [dismissible]=\"model.canClose\">\n  {{model.message}}\n</ngb-alert>\n";